import { LogisticOperator, LogisticOperatorApi } from '../models';

export function mapLogisticOperatorApiToModel(
  logisticOperatorApi: LogisticOperatorApi
): LogisticOperator {
  return {
    id: logisticOperatorApi.id,
    externalId: logisticOperatorApi.externalId || null,
    fullName: logisticOperatorApi.name,
    businessName: logisticOperatorApi.businessName,
    taxNumber: logisticOperatorApi.taxNumber,
    status: logisticOperatorApi.status,
    addressId: logisticOperatorApi.addressId,
    logisticOperatorGroupId: logisticOperatorApi.logisticOperatorGroupId,
    headquarter: logisticOperatorApi.headquarter ?? false,
    parentId: logisticOperatorApi.parentId ?? null,
    jsonConfig: logisticOperatorApi.jsonConfig ?? null,
    address: logisticOperatorApi.address,
  };
}
